import { map, OperatorFunction } from 'rxjs';
import { ISelectItem } from '@shared/models/interfaces/select-item.interface';
import { toNum } from '@shared/helpers/math.helper';

export function mapToSelectItems<T>(
    keySelector: keyof T | ((item: T) => string),
    valueSelector: keyof T | ((item: T) => string),
    idSelector?: keyof T
): OperatorFunction<T[], ISelectItem[]> {
    return map((list: T[]) =>
        (list ?? []).map((item) => ({
            key: typeof keySelector === 'function' ? keySelector(item) : String(item[keySelector] ?? ''),
            value: typeof valueSelector === 'function' ? valueSelector(item) : String(item[valueSelector] ?? ''),
            id: idSelector ? toNum(item[idSelector]) : null,
            isDisabled: false,
        }))
    );
}
